// extracted by mini-css-extract-plugin
module.exports = {"default":"index__default___v1MyV","alt":"index__alt___2OyYi"};